import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class CloneAlbumAPICall extends APICallV4 {
    _method = 'album/clone';
    _type: Method = 'post';
}
